"use strict";
var core_1 = require('@angular/core');
var RioAlert = (function () {
    function RioAlert() {
        this.status = 'info';
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], RioAlert.prototype, "status", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], RioAlert.prototype, "qaid", void 0);
    RioAlert = __decorate([
        core_1.Component({
            selector: 'rio-alert',
            template: "\n    <div\n      [id]=\"qaid\"\n      class=\"p2 bold\"\n      [ngClass]=\"{\n        'bg-blue': status === 'info',\n        'bg-yellow': status === 'warning',\n        'bg-green': status === 'success',\n        'bg-red': status === 'error',\n        'white': status === 'info' || status === 'error'\n      }\">\n      <ng-content></ng-content>\n    </div>\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], RioAlert);
    return RioAlert;
}());
exports.RioAlert = RioAlert;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEscUJBQWlDLGVBQWUsQ0FBQyxDQUFBO0FBbUJqRDtJQUFBO1FBQ1csV0FBTSxHQUFHLE1BQU0sQ0FBQztJQUUzQixDQUFDO0lBRkM7UUFBQyxZQUFLLEVBQUU7OzRDQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7OzBDQUFBO0lBbkJWO1FBQUMsZ0JBQVMsQ0FBQztZQUNULFFBQVEsRUFBRSxXQUFXO1lBQ3JCLFFBQVEsRUFBRSwyV0FhVDtTQUNGLENBQUM7O2dCQUFBO0lBSUYsZUFBQztBQUFELENBQUMsQUFIRCxJQUdDO0FBSFksZ0JBQVEsV0FHcEIsQ0FBQTtBQUFBLENBQUMifQ==


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/alert/index.ts
 ** module id = 957
 ** module chunks = 1
 **/